module.exports = __webpack_public_path__ + "static/img/footer_logo.6e31855f.png";